import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { EsnToastService } from '../../../shared/toast.service';
import type { EsnToastPlacement } from '../../../shared/types/molecules';
import { ToastComponent } from '../toast/toast.component';

/**
 * Renders the app-wide toast queue, so any page can confirm an outcome with one `show()` call.
 * Place it once: in the rail's foot on wide screens (`inline`) or in the viewport corner (`corner`).
 */
@Component({
  selector: 'esn-toast-outlet',
  imports: [ToastComponent],
  templateUrl: './toast-outlet.component.html',
  styleUrl: './toast-outlet.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.esn-toast-outlet--corner]': 'placement() === "corner"' },
})
export class ToastOutletComponent {
  readonly placement = input<EsnToastPlacement>('corner');

  protected readonly service = inject(EsnToastService);
  protected readonly toasts = this.service.toasts;
}
